import { ColorLabelEnum, hexColor } from '@utils/map/map.constants';

import { FatoStateEnum, FatoTypeEnum } from '@/types/intercom/intercom.types';

export const VERTIPORT_DIAMETER_SCALE = 55;

export const FatoStateLabelColor: Record<FatoStateEnum, ColorLabelEnum> = {
  [FatoStateEnum.NOMINAL]: ColorLabelEnum.GREEN,
  [FatoStateEnum.CONTINGENCY]: ColorLabelEnum.ORANGE,
  [FatoStateEnum.INOPERABLE]: ColorLabelEnum.RED,
};

export const FatoStateColor: Record<FatoStateEnum, string> = {
  [FatoStateEnum.NOMINAL]: hexColor.GREEN,
  [FatoStateEnum.CONTINGENCY]: hexColor.ORANGE,
  [FatoStateEnum.INOPERABLE]: hexColor.RED,
};

export const FatoTypeTrigram: Record<FatoTypeEnum, string> = {
  [FatoTypeEnum.LANDING]: 'LAN',
  [FatoTypeEnum.TAKE_OFF]: 'TOF',
  [FatoTypeEnum.HYBRID]: 'FAT',
  [FatoTypeEnum.CONTINGENCY]: 'DL',
};
